import React, { ReactNode } from 'react';
import { Box } from '@primer/components';
import { OverlayTrigger } from 'react-bootstrap';
import { Tooltip } from '../Tooltip';
import './OverlayTooltip.scss';

export type TooltipPlacement = 'top' | 'bottom';
type TooltipVariant =
    | 'default'
    | 'north'
    | 'northeast'
    | 'east'
    | 'southeast'
    | 'south'
    | 'southwest'
    | 'west'
    | 'northwest';

interface Props {
    label: string | ReactNode;
    placement?: TooltipPlacement;
    height?: string;
    tooltipVariant?: TooltipVariant;
}

const OverlayTooltip: React.FC<Props> = ({
    label,
    children,
    placement = 'bottom',
    height,
    tooltipVariant,
    ...rest
}) => (
    <div className="overlay-tooltip">
        <OverlayTrigger
            placement={placement}
            overlay={
                label ? (
                    <Box
                        paddingTop={placement === 'bottom' ? '10px' : '0px'}
                        paddingBottom={placement === 'bottom' ? '0px' : '10px'}
                    >
                        <Tooltip
                            variant={
                                tooltipVariant ||
                                (placement === 'bottom' ? 'south' : 'north')
                            }
                            tooltipLabel={label}
                        />
                    </Box>
                ) : (
                    <div />
                )
            }
            {...rest}
            rootClose
        >
            <Box height={height}>{children}</Box>
        </OverlayTrigger>
    </div>
);

export default OverlayTooltip;
